module.exports = __webpack_public_path__ + "static/media/jemstone-logo.4ed81489.png";